import { chain, find } from 'lodash'
import { useSnackbar } from 'notistack'
import { useContext, useEffect, useState } from 'react'
import { Navigate, useNavigate } from 'react-router'

import { AppContext } from 'providers/context/App'
import { anyEsth } from 'providers/context/EstheticianList'
import { useLoading } from 'providers/context/Loading'
import { createCart, getCart } from 'services/Cart'
import {
  LASER_ESTHETICIAN_LIST_ROUTE,
  LASER_FACIAL_LOCATION,
  LOCATIONS_ROUTE,
} from 'utils/constants/Helpers'
import { GENERAL_ERROR_MESSAGE } from 'utils/constants/Messages'
import { services } from 'utils/constants/services'
import { FAILED_CREATE_LASER_FACIAL } from 'utils/sentry/sentry-messages'
import { captureError } from 'utils/sentry/sentry-utils'
import { AvailableItems } from 'utils/types/cartTypes'

const LaserFacialLanding = () => {
  const { appMasterData, updateData } = useContext(AppContext)
  const navigate = useNavigate()
  const { setLoading } = useLoading()
  const { enqueueSnackbar } = useSnackbar()
  const [cartReady, setCartReady] = useState(false)

  const createLaserFacial = async () => {
    try {
      // Handling two scenarios: one with straight '/leser' and one coming from the '/locations' screen.

      const laserFacialLocation =
        appMasterData?.location?.locationId || LASER_FACIAL_LOCATION
      const createdCart = await createCart(laserFacialLocation)
      const getLaserFacialObj: AvailableItems = chain(
        createdCart.createCart.cart.availableCategories
      )
        .filter({ name: 'Laser' })
        .take()
        .first()
        .thru((x) => find(x.availableItems, { id: services?.[1]?.id }))
        .value()
      // No the elite laser facial data redirect to locations screen
      if (!getLaserFacialObj) {
        return navigate(LOCATIONS_ROUTE)
      }
      const getCartValues = await getCart(
        createdCart.createCart.cart.id,
        getLaserFacialObj.id
      )

      const staffVariants = getCartValues.cart.availableItem.staffVariants

      staffVariants.unshift(anyEsth)

      updateData({
        cart: {
          ...appMasterData.cart,
          cartId: createdCart.createCart.cart.id ?? '',
        },
        category: {
          categoryId: getLaserFacialObj.id,
          categoryObj: getLaserFacialObj,
        },
        availableEstheticians: staffVariants,
        selectedEnhancements: [],
        isLaserFacial: true,
      })
    } catch (error) {
      console.error(error)
      captureError(FAILED_CREATE_LASER_FACIAL, {
        email: appMasterData.userInfo.email,
        location: appMasterData.location,
        error,
        functionName: 'createLaserFacial',
      })
      enqueueSnackbar(GENERAL_ERROR_MESSAGE, {
        variant: 'error',
      })
    } finally {
      setCartReady(true)
      setLoading(false)
    }
  }

  useEffect(() => {
    setLoading(true)
    createLaserFacial()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return cartReady ? <Navigate to={LASER_ESTHETICIAN_LIST_ROUTE} /> : <></>
}

export default LaserFacialLanding
